import { string } from 'prop-types'

export const logoPropsType = {
  title: string.isRequired,
  alt: string.isRequired,
}
